import FilledButtonM from "@common/components/button/FilledButtonM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { useIsFocusedM } from "@common/hooks/useIsFocusedM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { formIds } from "@data/constants/formConstants"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setRecentlyOpened } from "@data/redux/actions/camera"
import { setTodoActivities } from "@data/redux/actions/data"
import { setIsLiveModeEnabled } from "@data/redux/actions/liveMode"
import { authService } from "@data/services/authService"
import { liveService } from "@data/services/liveService"
import { hasRole } from "@data/utility/ability"
import {
    LIVE_DAY,
    liveDayFromToday,
    nextLiveFromToday,
} from "@data/utility/liveDay"
import { capitalize } from "@data/utility/Utils"
import { isSamOpenFor } from "@data/constants/samConstants"
import * as amplitude from "@amplitude/analytics-react-native"
import { TabActions, useNavigation, useRoute } from "@react-navigation/native"
import moment from "moment"
import React, { useContext, useEffect, useRef, useState } from "react"
import { Dimensions, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import live from "../../../../assets/icons/generic/live.png"
import { resetUploadedFiles } from "../../../data/redux/actions/formData"
import { ChampionImageM } from "../../champions/ChampionImageM"
import PaymentBlockedModal from "../../tutoring/PaymentBlockedModal"
import RescheduleTrialLiveSessionModal from "../../tutoring/RescheduleTrialLiveSessionModal"
import SendTutorMessageModal from "../../tutoring/SendTutorMessageModal"
import StudentLiveSessionsListModal from "../../tutoring/StudentLiveSessionsListModal"
import { showLiveNotTodayDialog } from "../../tutoring/showLiveNotTodayDialog"
import { showLiveTodayDialog } from "../../tutoring/showLiveTodayDialog"
import { useReloadBeforeRefusing } from "../../tutoring/useReloadBeforeRefusing"
import { BANNER_GO, bannerGoAnswer } from "./bannerGoAnswer"

/**
 * Retard et absence signalés pour le prochain live. Les DEUX variantes du
 * bandeau les portent : le swap Sam change la priorité du CTA, il n'a aucune
 * raison de retirer une information de présence, que le parent lit depuis cet
 * écran. Sur le fond violet de Sam, ils passent en blanc.
 */
const AttendanceNotices = ({ counts, firstname, onSamBanner = false }) => (
    <>
        {counts?.late > 0 && (
            <TextM
                color={onSamBanner ? theme.colors.white : theme.colors.warning}
                fontWeight={onSamBanner ? "Bold" : "Medium"}
                fontSize={11}
                wrap={onSamBanner}
            >
                Retard de {firstname} signalé
            </TextM>
        )}
        {counts?.absence > 0 && (
            <TextM
                color={onSamBanner ? theme.colors.white : theme.colors.error}
                fontWeight={onSamBanner ? "Bold" : "Medium"}
                fontSize={11}
                wrap={onSamBanner}
            >
                Absence de {firstname} signalée
            </TextM>
        )}
    </>
)

const NextLiveSessionBanner = (props) => {
    const {
        noButton = false,
        subscriptionUser = null,
        forceAllLivesButton = false,
        tutorIds = 0,
        showLivesButton = true,
    } = props

    const route = useRoute()
    const showLivesModal =
        route?.params?.show_lives === true ||
        route?.params?.show_lives === "true"

    const user = subscriptionUser ?? props.user

    const formId = formIds.SEND_TUTOR_MESSAGE

    const dimensions = useContext(DimensionsContext)

    const navigation = useNavigation()

    const closestNextLiveSessionOccurrence = nextLiveFromToday(
        user?.live_sessions
    )

    const closestNextLiveSession = user?.live_sessions?.find(
        (x) => x?.id === closestNextLiveSessionOccurrence?.live_session_id
    )
    const liveMoment = moment(closestNextLiveSessionOccurrence?.date)
    const isToday =
        liveDayFromToday(closestNextLiveSessionOccurrence?.date) ===
        LIVE_DAY.TODAY

    const [selectLiveSessionModalVisible, setSelectLiveSessionModalVisible] =
        useState(false)
    const [bModel, setBModel] = useState(false)

    const attendanceCountsForOccurrence = [closestNextLiveSession]?.reduce(
        (counts, session) => {
            session?.attendance_flags?.forEach((flag) => {
                if (
                    flag.type === "late" &&
                    user?.id === flag?.user_id &&
                    flag?.date === closestNextLiveSessionOccurrence?.date
                ) {
                    counts.late += 1
                } else if (
                    flag.type === "absent" &&
                    user?.id === flag?.user_id &&
                    flag?.date === closestNextLiveSessionOccurrence?.date
                ) {
                    counts.absence += 1
                }
            })
            return counts
        },
        { late: 0, absence: 0 }
    )

    const isTrial =
        props.user?.subscription_state?.status === "on_generic_trial" &&
        Math.abs(moment().diff(moment(props.user?.trial_ends_at), "days")) <= 7

    // Sam swap — when we're not on the live day and the student has at
    // least one pending activity, the banner CTA flips from "GO !" to
    // "Étudier avec Sam" pointing to the first todo. Gated on the global
    // kill switch AND the per-user eligibility flag (sam_eligible, exposed
    // by UserResource: every student with a formula). Only on the student's
    // own home: the parent space shows this banner for the child
    // (`subscriptionUser`, no button), and a nudge to study is not for them.
    const samEligible =
        isSamOpenFor(props.user) && !subscriptionUser && !noButton
    const todoActivities = user?.todo_activities ?? []
    const firstPendingActivityId = todoActivities[0]?.id ?? null
    const samBannerActive =
        samEligible && !isToday && !!firstPendingActivityId
    const samBannerShownRef = useRef(false)

    useEffect(() => {
        if (samBannerActive && !samBannerShownRef.current) {
            samBannerShownRef.current = true
            amplitude.track("sam.banner.shown", {
                prescribed_count: todoActivities.length,
            })
        }
        if (!samBannerActive) samBannerShownRef.current = false
    }, [samBannerActive, todoActivities.length])

    const [openLiveSessionsListModal, setOpenLiveSessionsListModal] =
        useState(false)
    const handleShowModal = () => {
        setOpenLiveSessionsListModal(!openLiveSessionsListModal)
    }

    const [openSendTutorMessageModal, setOpenSendTutorMessageModal] =
        useState(false)
    const handleShowSendTutorMessageModal = () =>
        setOpenSendTutorMessageModal(!openSendTutorMessageModal)

    const [sendTutorMessageTutor, setSendTutorMessageTutor] = useState(0)

    const allMyNextLiveSessions = props.allMyNextLiveSessions
    const paymentBlocked = props.paymentBlocked
    const paymentUrl = props.paymentUrl
    const isBlockedStudent = !subscriptionUser && paymentBlocked
    const isPaymentBlocked = isBlockedStudent && isToday
    const bannerColor = isBlockedStudent
        ? theme.colors.warning
        : theme.colors.success
    const [paymentModalVisible, setPaymentModalVisible] = useState(false)

    const liveSessions =
        allMyNextLiveSessions?.length > 0
            ? allMyNextLiveSessions
            : user?.live_sessions

    const tutorIdsArray = tutorIds !== 0 ? tutorIds.split(",") : []
    const isFocused = useIsFocusedM()

    const studyWithSam = () => {
        amplitude.track("sam.banner.clicked", {
            prescribed_count: todoActivities.length,
            target_activity_id: firstPendingActivityId,
        })
        navigation.push("sam-session", {
            activityId: firstPendingActivityId,
            entry_point: "banner",
        })
    }

    // `isToday` is frozen at the last render: GO reads the clock again.
    const answerGo = ({ canReload, onSamBanner = false }) => {
        const live = nextLiveFromToday(user?.live_sessions)
        const joinLive = () =>
            navigation.push("pre-call", {
                liveSessionId: live.live_session_id,
            })
        switch (
            bannerGoAnswer({
                liveDay: liveDayFromToday(live?.date),
                onSamBanner,
                canReload,
            })
        ) {
            case BANNER_GO.JOIN_LIVE:
                return joinLive()
            case BANNER_GO.CHOOSE_LIVE_OR_SAM:
                return showLiveTodayDialog(live.date, {
                    onJoinLive: joinLive,
                    onStudyWithSam: studyWithSam,
                })
            case BANNER_GO.STUDY_WITH_SAM:
                return studyWithSam()
            case BANNER_GO.RELOAD:
                return reloadThenAnswer()
            case BANNER_GO.REFUSE:
                return showLiveNotTodayDialog(live.date)
        }
    }
    const { reloadThenAnswer, isReloadingForGo } = useReloadBeforeRefusing({
        key: "next-live-banner",
        data: user,
        isReloading: props.getUserRequest,
        reload: () => props.apiRequest(authService.getUser),
        answer: () => answerGo({ canReload: false }),
        canAnswer: isFocused && !props.isLiveMode && !noButton,
    })

    useEffect(() => {
        if (tutorIdsArray.length > 0) {
            if (subscriptionUser && !bModel) {
                if (tutorIdsArray.length > 1) {
                    handleShowModal()
                    setBModel(true)
                } else {
                    setSendTutorMessageTutor(
                        liveSessions?.find(
                            (session) =>
                                session?.tutor?.id === parseInt(tutorIds)
                        )?.tutor
                    )
                    handleShowSendTutorMessageModal()
                    setBModel(true)
                }
            }
        }
    }, [subscriptionUser])

    useEffect(() => {
        props.resetUploadedFiles(formId)
    }, [formId])

    useEffect(() => {
        if (subscriptionUser && showLivesModal) {
            setOpenLiveSessionsListModal(true)
        }
    }, [])

    // Reopen modal after camera for subscribe screen
    useEffect(() => {
        if (props.recentlyOpenedCam && isFocused) {
            handleShowSendTutorMessageModal()
            props.setRecentlyOpenedCam(false)
        }
    }, [props.recentlyOpenedCam, isFocused])

    if (!hasRole(user, "student") || props.isLiveMode) {
        return null
    }

    return (
        (closestNextLiveSessionOccurrence || forceAllLivesButton) && (
            <View style={{ alignItems: "center" }}>
                {!!closestNextLiveSessionOccurrence && (
                    <View
                        style={{
                            width: Dimensions.get("window").width,
                            borderBottomWidth: 1,
                            borderColor: theme.colors.lightMore,
                            backgroundColor: isPaymentBlocked
                                ? theme.colors.warningLight
                                : isToday
                                  ? theme.colors.successLight
                                  : samBannerActive
                                    ? theme.colors.purple
                                    : theme.colors.white,
                            alignItems: "center",
                        }}
                    >
                        <View
                            style={{
                                width: dimensions?.width,
                                flexDirection: "row",
                                alignItems: "center",
                                flex: 1,
                                paddingVertical: 12,
                                paddingHorizontal: 15,
                            }}
                        >
                            {samBannerActive ? (
                                <View
                                    style={{
                                        width: 44,
                                        height: 44,
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <ChampionImageM name="sam" width={40} />
                                </View>
                            ) : (
                                <IconImageM
                                    source={live}
                                    width={30}
                                    style={{
                                        tintColor: bannerColor,
                                    }}
                                />
                            )}
                            <View
                                style={{
                                    flex: 1,
                                    marginLeft: 10,
                                    justifyContent: "center",
                                }}
                            >
                                {samBannerActive ? (
                                    <>
                                        <TextM
                                            color={theme.colors.white}
                                            fontWeight={"Bold"}
                                            fontSize={14}
                                            wrap
                                        >
                                            {`Prochain live ${liveMoment.fromNow()}`}
                                        </TextM>
                                        <TextM
                                            color={theme.colors.white}
                                            fontWeight={"Regular"}
                                            fontSize={12}
                                            style={{ opacity: 0.85 }}
                                            wrap
                                        >
                                            Étudie avec Sam en attendant
                                        </TextM>
                                        <AttendanceNotices
                                            counts={attendanceCountsForOccurrence}
                                            firstname={user?.firstname}
                                            onSamBanner
                                        />
                                    </>
                                ) : (
                                    <>
                                        <TextM
                                            color={bannerColor}
                                            fontWeight={"Regular"}
                                            fontSize={12}
                                            wrap
                                        >
                                            {"Prochaine session LIVE"}
                                        </TextM>
                                        <TextM
                                            color={bannerColor}
                                            fontWeight={"Bold"}
                                            wrap
                                        >
                                            {capitalize(
                                                isToday
                                                    ? liveMoment.format(
                                                          "[Aujourd'hui à] HH[h]mm"
                                                      )
                                                    : liveMoment.format(
                                                          "dddd DD MMMM [à] HH[h]mm"
                                                      )
                                            )}
                                        </TextM>
                                        <AttendanceNotices
                                            counts={attendanceCountsForOccurrence}
                                            firstname={user?.firstname}
                                        />
                                    </>
                                )}
                            </View>
                            {!noButton && (
                                <FilledButtonM
                                    onPress={() => {
                                        if (isBlockedStudent) {
                                            setPaymentModalVisible(true)
                                            return
                                        }
                                        answerGo({
                                            canReload: true,
                                            onSamBanner: samBannerActive,
                                        })
                                    }}
                                    icon={isBlockedStudent ? "lock" : undefined}
                                    loading={isReloadingForGo}
                                    color={
                                        isPaymentBlocked
                                            ? theme.colors.warning
                                            : isToday
                                              ? theme.colors.success
                                              : samBannerActive
                                                ? theme.colors.white
                                                : theme.colors.lightMore
                                    }
                                    textColor={
                                        samBannerActive
                                            ? theme.colors.purple
                                            : undefined
                                    }
                                    style={{
                                        width: isBlockedStudent ? 100 : 80,
                                        alignSelf: "flex-start",
                                        marginBottom: 0,
                                        height: 40,
                                    }}
                                    contentStyle={{
                                        height: 40,
                                    }}
                                    label={"GO !"}
                                />
                            )}
                        </View>
                        <RescheduleTrialLiveSessionModal
                            visible={selectLiveSessionModalVisible}
                            navigation={navigation}
                            setVisible={setSelectLiveSessionModalVisible}
                            notify
                        />
                    </View>
                )}
                {(closestNextLiveSessionOccurrence || forceAllLivesButton) &&
                    showLivesButton && (
                        <View
                            style={{
                                width: Dimensions.get("window").width,
                                borderBottomWidth: 1,
                                borderColor: theme.colors.lightMore,
                                backgroundColor: isToday
                                    ? theme.colors.successLight
                                    : theme.colors.white,
                                alignItems: "center",
                            }}
                        >
                            <TouchableRippleM
                                style={{
                                    width: dimensions?.width,
                                    flex: 1,
                                }}
                                onPress={() => {
                                    if (isTrial) {
                                        setSelectLiveSessionModalVisible(true)
                                    } else {
                                        if (subscriptionUser) {
                                            handleShowModal()
                                        } else {
                                            const jumpToAction =
                                                TabActions.jumpTo("tutor", {})
                                            navigation.dispatch(jumpToAction)
                                        }
                                    }
                                }}
                            >
                                <View
                                    style={{
                                        flex: 1,
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        paddingVertical: 14,
                                        paddingHorizontal: 15,
                                        backgroundColor: theme.colors.white,
                                    }}
                                >
                                    <FontAwesome5
                                        name={"calendar-alt"}
                                        size={16}
                                        color={theme.colors.primary}
                                    />
                                    <TextM
                                        fontWeight={"Bold"}
                                        color={theme.colors.primary}
                                        style={{
                                            textDecorationLine: "underline",
                                            marginLeft: 5,
                                        }}
                                        fontSize={13}
                                    >
                                        {isTrial
                                            ? "PAS DISPONIBLE ? REPLANIFIER"
                                            : "VOIR MES LIVES"}
                                    </TextM>
                                </View>
                            </TouchableRippleM>
                            {subscriptionUser && openLiveSessionsListModal && (
                                <StudentLiveSessionsListModal
                                    subscriptionUser={subscriptionUser}
                                    isOpen={openLiveSessionsListModal}
                                    navigation={navigation}
                                    handleShowModal={handleShowModal}
                                    handleShowSendTutorMessageModal={
                                        handleShowSendTutorMessageModal
                                    }
                                    sendTutorMessageTutor={
                                        sendTutorMessageTutor
                                    }
                                    setSendTutorMessageTutor={
                                        setSendTutorMessageTutor
                                    }
                                />
                            )}

                            {subscriptionUser && openSendTutorMessageModal && (
                                <SendTutorMessageModal
                                    subscriptionUser={subscriptionUser}
                                    isOpen={openSendTutorMessageModal}
                                    navigation={navigation}
                                    handleShowSendTutorMessageModal={
                                        handleShowSendTutorMessageModal
                                    }
                                    handleShowModal={handleShowModal}
                                    sendTutorMessageTutor={
                                        sendTutorMessageTutor
                                    }
                                    setSendTutorMessageTutor={
                                        setSendTutorMessageTutor
                                    }
                                    tutorIds={tutorIds}
                                    formId={formId}
                                />
                            )}
                        </View>
                    )}

                {/* Payment blocked modal */}
                <PaymentBlockedModal
                    visible={paymentModalVisible}
                    onDismiss={() => {
                        setPaymentModalVisible(false)
                        props.apiRequest(liveService.getAllMyNextLiveSessions)
                    }}
                    paymentUrl={paymentUrl}
                />
            </View>
        )
    )
}

const mapStateToProps = (state) => {
    return {
        activityTodoIndexesAsStudentRequest:
            state.api.activityTodoIndexesAsStudent?.request,
        activityTemplates: state.data.staticData?.activity_templates,
        user: state.data.currentUser?.object,
        schoolSubjects: state.data.staticData?.school_subjects,
        getUserRequest: state.api.getUser?.request,
        getStudentRequest: state.api.getStudent?.request,
        liveSessionId: state.liveMode?.liveSessionId,
        isLiveMode: state.liveMode.isLiveModeEnabled,
        recentlyOpenedCam: state.camera?.recentlyOpened,
        allMyNextLiveSessions: state.data.liveSessions?.full_list,
        paymentBlocked: state.data.currentUser?.object?.is_payment_blocked,
        paymentUrl: state.data.currentUser?.object?.payment_url,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setTodoActivities,
    setIsLiveModeEnabled,
    resetUploadedFiles,
    setRecentlyOpenedCam: setRecentlyOpened,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NextLiveSessionBanner)
